/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrCreateChatResponse } from '../../models/get-or-create-chat-response';

export interface GetOrCreateChatWithUser$Params {
  userId: number;
}

export function getOrCreateChatWithUser(http: HttpClient, rootUrl: string, params: GetOrCreateChatWithUser$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrCreateChatResponse>> {
  const rb = new RequestBuilder(rootUrl, getOrCreateChatWithUser.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrCreateChatResponse>;
    })
  );
}

getOrCreateChatWithUser.PATH = '/api/chat/get-or-create-with-user/{userId}';
